import { createContext } from 'react';

import {
  FilterOptions,
  Rule,
  RuleConnectionInput,
} from '@totem/components/rulesEngine/types';

interface Context {
  rulesData: Rule[];
  filterOptions: FilterOptions;
  loading: boolean;
  input: RuleConnectionInput;
  setInput: (input: RuleConnectionInput) => void;
  editingRule: Rule | null;
  modalOpen: boolean;
  saving: boolean;
  onRefresh: () => void;
  onAdd: () => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  onSave: (rule: Partial<Rule>) => void;
  onModalClose: () => void;
}

export default createContext<Context>({
  loading: false,
  rulesData: null,
  filterOptions: { domain: [], trigger: [], action: [], status: [], tags: [] },
  input: {},
  setInput: () => {},
  editingRule: null,
  modalOpen: false,
  saving: false,
  onRefresh: () => {},
  onAdd: () => {},
  onEdit: () => {},
  onDelete: () => {},
  onSave: () => {},
  onModalClose: () => {},
});
